var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 121.8 122",
    style: {
      enableBackground: "new 0 0 121.8 122"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.1,1.7c32.8,0,59.6,26.7,59.4,59.8c-0.2,32.9-26.9,59.2-59.4,59.1c-32.8,0-59.6-26.8-59.5-59.5 C1.7,28.2,28.3,1.7,61.1,1.7z M61.1,8.2c-29.3,0-53,23.8-53,53.2c0,29.1,23.9,52.9,53.2,52.8c29-0.1,52.8-23.9,52.8-53 C114.1,31.9,90.3,8.1,61.1,8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.9,74.7c1.5-1.6,2.9-3.3,4.3-4.9c7.4-8.3,14.7-16.5,22.1-24.8c2.5-2.8,5-5.6,7.5-8.4 c1.3-1.4,3.3-1.6,4.6-0.4c1.4,1.2,1.5,3.3,0.2,4.7c-8.3,9.4-16.7,18.7-25,28.1c-3.5,4-7.1,8-10.6,12c-1.4,1.6-3.1,1.8-4.8,0.5 c-7.5-5.9-14.9-11.9-22.3-17.8c-1.4-1.1-1.6-3.2-0.5-4.5c1.2-1.4,3.1-1.6,4.6-0.4c5.2,4.1,10.3,8.3,15.5,12.4 C50.9,72.3,52.4,73.5,53.9,74.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.920a80cf2c1203292a25829d8f3b8eed.svg";
export { ForwardRef as ReactComponent };